<script>
    let { yScale,
        ticks = [0, 10, 20, 30, 40, 50, 60, 70, 80],
        unit = '',
        chartwidth = 400,
        part = 'all' // 'lines' | 'labels' | 'all'
     } = $props();

    const topTick = $derived(Math.max(...ticks));

    const label = tick => {
        let s = `${tick}`;
        if (tick === topTick && unit) s += unit;
        return s;
    };
</script>
<g class="y-axis">

    {#if part === 'lines' || part === 'all'}
        {#each ticks as tick, i}
            <line class="y-tick"
                x1={0}
                x2={chartwidth}
                y1={yScale(tick)} y2={yScale(tick)}
            >
            </line>
        {/each}
    {/if}

    {#if part === 'labels' || part === 'all'}
        {#each ticks as tick, i}
            <text x=0 y={yScale(tick) - 4} class="tick-text halo">{label(tick)}</text>
            <text x=0 y={yScale(tick) - 4} class="tick-text">{label(tick)}</text>
        {/each}
    {/if}

</g>
<style lang='scss'>
    .tick-text {
        font-size: 11px;
        fill: #666;

        &.halo {
            fill: #fff;
            stroke: #fff;
            stroke-width: 2.5;
            stroke-linejoin: round;
        }
    }
    .y-tick {
        stroke: #e0e0e0;
    }
</style>